import { CardTitle, Caption } from "@/components/ui";
import { V2Notifications } from "@/v2/layout/v2Notifications";
import { V2UserMenu } from "@/v2/layout/v2UserMenu";

export function V2Header(): React.JSX.Element {
  return (
    <header className="bg-primary-800 text-on-primary">
      <div className="flex h-16 items-center gap-4 px-6">
        <div className="flex h-11 w-[48px] shrink-0 items-center justify-center overflow-hidden rounded-md ring-1 ring-on-primary/15">
          <img
            src="/politie-wordmark.jpg"
            alt="Politiezone Antwerpen"
            className="block h-[54px] w-auto max-w-none"
          />
        </div>

        <div className="flex-1 leading-tight">
          <CardTitle className="font-semibold tracking-tight text-on-primary">
            Praesidium
          </CardTitle>
          <Caption as="p" className="text-primary-200">
            Politiezone Antwerpen
          </Caption>
        </div>

        <V2Notifications />
        <V2UserMenu />
      </div>
    </header>
  );
}
